import React from "react";

class Main404Container extends React.Component<any, any> {
    render() {
        return (
            <div id="error-404">
                <h1>404 Not Found</h1>
                <p>
                    Looks like I misplaced whatever you were looking for.
                </p>
                <p>
                    If you are looking for the <strong>LEGO UCS Royal Tie Interceptor</strong> <a href="/lego/lego-imperial-royal-guard-tie-interceptor.lxf">you can find it here</a>
                    <br/>
                    I moved it to add more MOCs at a later date.
                </p>
            </div>
        );
    }
}

function Error404Component() {
    return <Main404Container />;
}

export default Error404Component;